import { createReactBlockSpec } from "@blocknote/react";
import { InlineImage } from "../../components/InlineImage";
import { ImageBlock } from "./ImageBlock";

export const ImageBlockSpec = createReactBlockSpec(
  {
    type: "imageBlock",
    propSchema: {
      image: {
        default: "",
      },
      alt: {
        default: "",
      },
      url: {
        default: "",
      },
      caption: {
        default: "",
      },
      pixelWidth: {
        default: 0,
      },
    },
    content: "none",
    isSelectable: true,
  },
  {
    render: ({
      editor,
      block: {
        id,
        props: { image, alt, url, caption, pixelWidth },
      },
    }) => {
      const updateBlock = (
        newProps: Partial<{
          image: string;
          alt: string;
          url: string;
          caption: string;
          pixelWidth: number;
        }>,
      ) => {
        // biome-ignore lint/suspicious/noExplicitAny:
        editor.updateBlock(id, { props: newProps as any });
      };

      return (
        <ImageBlock
          image={image}
          alt={alt}
          url={url}
          caption={caption}
          pixelWidth={pixelWidth || 0}
          updateBlock={updateBlock}
        />
      );
    },
    toExternalHTML: ({
      block: {
        props: { image, alt, url, caption, pixelWidth },
      },
    }) => {
      return <InlineImage alt={alt} image={image} caption={caption} pixelWidth={pixelWidth} url={url} />;
    },
  },
);
